var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"#6A6E7B","outlined":"","loading":_vm.loading},on:{"click":function($event){return _vm.makeDownload()}}},[_vm._v(" Baixar ")])
}
var staticRenderFns = []

export { render, staticRenderFns }